var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container button-group"},[_c('b-button',{staticClass:"button-blue",attrs:{"type":"submit"},on:{"click":_vm.onClientClick}},[_vm._v(" Já sou cliente ")]),_c('a',{staticClass:"button-bp-solutions",attrs:{"href":_vm.solutionsLink}},[_vm._v(" Conheça as soluções "),_c('i',[_vm._v("BP")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }